export class NodeListHelper {
	static toArray<T>(nodeList : NodeList): Array<T> {
		return [].slice.call(nodeList);
	}
}
